import { DrawerFulfillmentConfiguration } from './fulfillment-configuration/container';
import SingleShipmentDisplay from '../../../../fulfillment-plans/shipments-display/single-outbound-shipment-display/connected-order-context';
import CancelledIndicator from '../../../cancelled-indicator';
import { OrderAwaitingPayment } from '../order-awaiting-payment';
import style from './single-order-csw.module.css';

/**
 * @param {object} props
 * @param {string} [props.fulfillmentPlanId]
 * @param {boolean} [props.isAwaitingPayment]
 * @param {boolean} [props.isCancelled]
 * @param {boolean} [props.isCreatingReturn]
 * @param {(fulfillmentPlanId: string) => void} [props.restore]
 * @param {string} [props.salesOrderId]
 * @param {boolean} [props.shouldShowCompletedIndicator]
 * @param {boolean} [props.shouldShowShipmentWidget]
 * @returns {JSX.Element}
 */
export const ConfigureShipmentSectionContent = ({
  fulfillmentPlanId,
  isAwaitingPayment,
  isCancelled,
  isCreatingReturn,
  restore,
  salesOrderId,
  shouldShowCompletedIndicator,
  shouldShowShipmentWidget,
}) => {
  return (
    <>
      {!isCreatingReturn && shouldShowCompletedIndicator ? (
        <div className={style['base-content-container']}>
          <SingleShipmentDisplay fulfillmentPlanId={fulfillmentPlanId} />
        </div>
      ) : null}
      {shouldShowShipmentWidget ? <DrawerFulfillmentConfiguration fulfillmentPlanId={fulfillmentPlanId} /> : null}
      {isCancelled ? (
        <div className={style['base-content-container']}>
          <CancelledIndicator fulfillmentPlanId={fulfillmentPlanId} restore={restore} />
        </div>
      ) : null}
      {isAwaitingPayment ? <OrderAwaitingPayment salesOrderId={salesOrderId} /> : null}
    </>
  );
};
